<template lang="pug">
  .list-inventories
    v-overlay(v-if="update", :value="loading")
      v-progress-circular(indeterminate, size="64")
    v-card
      v-toolbar(color="primary", dark, flat)
        v-toolbar-title Lista de inventarios de {{ name }}
    v-card-text
      v-list
        v-list-item(v-for='inventory in inventories' :key='inventory.id')
          v-list-item-content
            v-list-item-title(v-text='inventory.code')

</template>

<script>
export default {
name: "ListInventories",
props: {
  inventories: {
    type: Array,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: true,
    required: false
  },
  error: {
    type: Object,
    required: false,
    default: () => {},
  },
},
}
</script>
